import { SolidMerchantDataRequest, SolidMerchantDataResponse, SolidPostInitRequest } from 'api/types/payment';

import * as actionTypes from './actionTypes';

export const initSolidPayment = (payload: Partial<SolidMerchantDataRequest>) => {
    return { type: actionTypes.INIT_SOLID_PAYMENT, payload } as const;
};

export const setSolidMerchantData = (payload: SolidMerchantDataResponse) => {
    return { type: actionTypes.SET_SOLID_MERCHANT_DATA, payload } as const;
};

export const setIsMerchantLoading = (payload: boolean) => {
    return { type: actionTypes.SET_MERCHANT_LOADING, payload } as const;
};

export const solidValidate = (payload: SolidPostInitRequest) => {
    return { type: actionTypes.SOLID_POST_INIT, payload } as const;
};
